<template>
  <div class="browser-content-metadata">
    <div class="title">{{ $t("List of tags") }}</div>
    <ul>
      <li
        ref="elements"
        v-for="(element, index) in content"
        @click="$emit('input', element.id)"
        :key="index"
        :class="[
          'browser-content-element',
          { 'is-highlighted': element.isSelected },
        ]"
      >
        <div v-if="element.hasTag">
          <span v-for="(tag, index) in element.tags">
            <b-tag id="tag" :type="tagColor(tag)">
              {{ element.content.substr(tag.offset, tag.length) }}
            </b-tag>
            {{ tag.name }} |
            <span v-for="(attribute, index) in tagAttributes(tag)">
              {{ attribute }} |
            </span>
            <br />
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: [Array],
      required: true,
    },
    selected: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    searchTag(element, text) {
      const found = element.tags.find(
        (x) =>
          x.length === text.length && x.offset === element.content.indexOf(text)
      );
      if (found) {
        return true;
      }
      return false;
    },
    tagColor(tag) {
      return "is-" + tag.name;
    },
    tagAttributes(tag) {
      var attributes = [];
      for (var attribute in tag.attributes) {
        if (attribute !== "offset") {
          if (attribute !== "length") {
            attributes.push(attribute + ":" + tag.attributes[attribute]);
          }
        }
      }
      return attributes;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/colors.scss";

.browser-content-metadata {
  padding: 0.75rem;
  height: 100%;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: large;
}
</style>
